import React, { useState } from "react";
import "./Verify.css";
import { useLocation, useNavigate } from "react-router-dom";
import { verifyUserOTP } from "../../Services/UserService";

const Verify = () => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const { phoneNumber, randomCode } = location.state || {};

  const handleVerifyOTP = async () => {
    if (!otp || otp.length < 4) {
      setError("Please enter a valid OTP");
      return;
    }

    if (!phoneNumber || !randomCode) {
      setError("Session expired. Please login again.");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await verifyUserOTP(otp, phoneNumber, randomCode);

      if (response.status === true || response.statusCode === 200) {
        // Store token in localStorage
        if (response.data && response.data.token) {
          localStorage.setItem("authToken", response.data.token);
          localStorage.setItem("userId", response.data.id);
          localStorage.setItem("phoneNumber", response.data.phoneNumber);
        }

        setSuccess(response.message || "Login successful!");
        
        // Navigate to home page after a short delay
        setTimeout(() => {
          navigate("/Home");
        }, 1500);
      } else {
        setError(response.message || "OTP verification failed. Please try again.");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Only allow digits
    setOtp(value);
    setError(null);
    setSuccess(null);
  };

  return (
    <div>
      <>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>OTP Verification</title>
        <link rel="stylesheet" href="style.css" />
        <div className="otp-container">
          <header className="otp-header">
            <p>Welcome to</p>
          </header>
          <main className="otp-box">
            <h2>Verification</h2>
            <label className="otp-label">Enter your OTP</label>
            <div className="otp-input-group">
              <label htmlFor="otp" className="otp-text">
                OTP
              </label>
              <input
                type="text"
                id="otp"
                placeholder=""
                value={otp}
                onChange={handleOtpChange}
                disabled={loading}
                maxLength={6}
              />
            </div>

            {error && (
              <div className="text-danger mb-3 mt-3">
                <p>{error}</p>
              </div>
            )}

            {success && (
              <div className="text-success mb-3 mt-3">
                <p>{success}</p>
              </div>
            )}

            <div className="buttons">
              <button
                className="submit-btn"
                onClick={handleVerifyOTP}
                disabled={loading || !otp}
              >
                {loading ? "Verifying..." : "Submit"}
                <span className="arrow">➜</span>
              </button>
            </div>
          </main>
        </div>
      </>
    </div>
  );
};

export default Verify;
